import { GET_LAST_SCORE_CARD } from "../types/scoreCardTypes";
import createAsyncActions from "../../../utilities/createAsyncActions";
import { createAction } from "redux-actions";
import { SET_ITEMS_PER_PAGE_SCORING_LOGS,SET_CURRENT_PAGE_SCORING_LOGS } from "../types/getLastScoringLogsTypes";

export const {
  getLastScoreCard,
  getLastScoreCardPending,
  getLastScoreCardFulfilled,
  getLastScoreCardRejected,
} = createAsyncActions(GET_LAST_SCORE_CARD, "getLastScoreCard");

export const setCurrentPageScoringLogs = createAction(
  SET_CURRENT_PAGE_SCORING_LOGS
);

export const setItemsPerPageScoringLogs = createAction(
  SET_ITEMS_PER_PAGE_SCORING_LOGS
);


// WEBPACK FOOTER //
// ./src/features/score-card/actions/getLastScoreCardActions.js